
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useCountryName } from "../../Components/Countries.js";
import { unwrap, map, defaultArg, bind } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { isEmpty, ofArray, singleton, map as map_1, append, empty, tryFind } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { LocationId__get_unwrap } from "../../Shared/Shared.js";
import { Hierarchy_getPath, Hierarchy_getAncestors, Hierarchy_getChildren } from "../../Shared/Location.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { Msg } from "./Types.js";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { LabeledClickableValue, LabeledValue } from "../../Components/Text.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initViewLocationView } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function LocationDetails(props) {
    let elems_4, Title, elems_3, elems_2;
    const t = useTranslation()[0];
    const countryName = useCountryName();
    const parentLocation = bind((parentLocationId) => tryFind((location) => (LocationId__get_unwrap(location.Id) === parentLocationId), props.Locations), props.Location.ParentLocationId);
    const subLocations = defaultArg(map((location_2) => Hierarchy_getChildren(props.Locations, location_2.Id), tryFind((location_1) => (LocationId__get_unwrap(location_1.Id) === props.Location.Id), props.Locations)), empty());
    const ancestors = defaultArg(map((location_4) => Hierarchy_getAncestors(props.Locations, location_4), tryFind((location_3) => (LocationId__get_unwrap(location_3.Id) === props.Location.Id), props.Locations)), empty());
    const hierarchyPath = join(" > ", append(map_1((_arg) => _arg.Name, ancestors), singleton(props.Location.Name)));
    const navigateToLocation = (location_5) => {
        RouterModule_nav(ofArray(["locations", LocationId__get_unwrap(location_5.Id)]), 1, 1);
    };
    return reactElement("div", createObj(singleton((elems_4 = [createElement(ConfirmationDialog, (Title = t("general.remove"), {
        Description: t("location.delete_confirmation"),
        FormState: props.FormState,
        IsOpen: props.IsDeleteDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(1, []));
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(2, []));
        },
        Title: Title,
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[75rem]"])], (elems_3 = [createElement(DetailViewHeader, {
        Badges: empty(),
        OnBack: () => {
            RouterModule_nav(ofArray(["locations"]), 1, 1);
        },
        OnDelete: () => {
            props.Dispatch(new Msg(0, []));
        },
        OnEdit: () => {
            RouterModule_nav(ofArray(["locations", props.Location.Id, "edit"]), 1, 1);
        },
        SubTitle: unwrap(isEmpty(ancestors) ? undefined : hierarchyPath),
        Title: props.Location.Name,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "mb-3", "bg-white", "rounded", "px-12", "py-9"])], (elems_2 = toList(delay(() => append_1(singleton_1(LabeledValue({
        Label: t("general.name"),
        Value: props.Location.Name,
    })), delay(() => append_1(singleton_1(LabeledValue({
        Label: t("general.description"),
        Value: props.Location.Description,
    })), delay(() => {
        let matchValue, parentLocation_1;
        return append_1((matchValue = parentLocation, (matchValue == null) ? (empty_1()) : ((parentLocation_1 = matchValue, singleton_1(LabeledClickableValue({
            ComponentState: "enabled",
            Label: t("location.parent_location"),
            OnClick: () => {
                navigateToLocation(parentLocation_1);
            },
            TestId: "location-detail-parent-location",
            Value: Hierarchy_getPath(props.Locations, parentLocation_1),
        }))))), delay(() => append_1(singleton_1(LabeledValue({
            Label: t("location.hierarchy_path"),
            Value: hierarchyPath,
        })), delay(() => {
            let elems_1, elems;
            return append_1(!isEmpty(subLocations) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3"])], (elems_1 = [reactElement("div", {
                className: join(" ", ["font-bold", "mb-1"]),
                children: t("location.sub_locations"),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1", "text-lg"])], ["data-test-id", "location-detail-sub-locations"], (elems = toList(delay(() => map_1((subLocation) => reactElement("div", {
                key: LocationId__get_unwrap(subLocation.Id),
                className: join(" ", ["text-primary-link", "font-medium", "cursor-pointer", "w-fit"]),
                "data-test-id": concat("location-detail-sub-location-", ...LocationId__get_unwrap(subLocation.Id)),
                onClick: (_arg_7) => {
                    navigateToLocation(subLocation);
                },
                children: subLocation.Name,
            }), subLocations))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty_1(), delay(() => append_1(singleton_1(LabeledValue({
                Label: t("location.address.street"),
                Value: defaultArg(props.Location.Address.Street, ""),
            })), delay(() => append_1(singleton_1(LabeledValue({
                Label: t("location.address.address_supplement"),
                Value: defaultArg(props.Location.Address.AddressSupplement, ""),
            })), delay(() => append_1(singleton_1(LabeledValue({
                Label: t("location.address.zip_code"),
                Value: defaultArg(props.Location.Address.ZipCode, ""),
            })), delay(() => append_1(singleton_1(LabeledValue({
                Label: t("location.address.city"),
                Value: defaultArg(props.Location.Address.City, ""),
            })), delay(() => append_1(singleton_1(LabeledValue({
                Label: t("location.address.country"),
                Value: countryName(props.Location.Address.Country),
            })), delay(() => (isFeatureEnabled(new Feature(17, [])) ? singleton_1(LabeledValue({
                Label: t("business_units.business_unit"),
                Value: defaultArg(props.Location.BusinessUnitName, ""),
            })) : empty_1())))))))))))));
        }))));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))]))));
}

export function LocationDetailsView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initViewLocationView, update_1, (_arg, _arg_1) => {
    }), props.LocationId, [props.LocationId]);
    const state_1 = patternInput[0];
    const matchValue = state_1.Location;
    const matchValue_1 = state_1.Locations;
    let matchResult, location, locations;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            matchResult = 0;
            location = matchValue.fields[0];
            locations = matchValue_1.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return createElement(LocationDetails, {
                Dispatch: patternInput[1],
                FormState: state_1.FormState,
                IsDeleteDialogOpen: state_1.IsDeleteDialogOpen,
                Location: location,
                Locations: locations,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

